import { BaseResponse, parseErrorContainer } from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"
import type { RequestOptions } from "../../tastyworks/http"
import { PREFERENCES_DESER, Preferences } from "../../tastyworks/preferences"

export class PreferencesService {
  private readonly httpClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.httpClient = baseHttpClient
  }

  readonly show = async (namespaces?: string[], options?: RequestOptions) =>
    this.httpClient.show(
      new Preferences(),
      PREFERENCES_DESER.update,
      "/preferences",
      { namespaces },
      undefined,
      options
    )

  readonly update = async (body: any): Promise<BaseResponse> => {
    const helper = await this.httpClient.patch("/preferences", body)

    const response = new BaseResponse()
    parseErrorContainer(helper, response)

    return response
  }
}
